// @todo move to the api request type
export enum ESaleAgentClientName {
    FULL_BUY_SITE = 'FULL_BUY_SITE',
    FULL_BUY_EQUIPMENT_SITE = 'FULL_BUY_EQUIPMENT_SITE',
}
